import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  // Set current date as effective date if not specified
  const effectiveDate = "May 14, 2025";

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy for Stickersby.ai</h1>
        <p className="text-gray-600 mb-8">Effective Date: {effectiveDate}</p>

        <p className="mb-8">
          At Stickersby.ai, your privacy matters. This Privacy Policy explains what information we
          collect, how we use it, and the choices you have when using our website and services.
        </p>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">1. What We Collect</h2>
          <p className="mb-4">
            We collect personal and usage information to operate our site and provide you with a
            great experience.
          </p>

          <h3 className="font-medium mt-4 mb-2">Information you provide:</h3>
          <ul className="list-disc pl-8 mb-4 space-y-1">
            <li>Email address (when you register or sign in)</li>
            <li>Payment information (processed securely via our payment provider)</li>
            <li>Prompts and image edits you submit for sticker generation</li>
          </ul>

          <h3 className="font-medium mt-4 mb-2">Information we collect automatically:</h3>
          <ul className="list-disc pl-8 space-y-1">
            <li>Device and browser information</li>
            <li>IP address and general location</li>
            <li>Site interaction data (e.g., pages visited, actions taken)</li>
          </ul>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">2. How We Use Your Information</h2>
          <p className="mb-4">We use your information to:</p>
          <ul className="list-disc pl-8 mb-4 space-y-1">
            <li>Generate and deliver custom stickers</li>
            <li>Improve our services and personalize your experience</li>
            <li>Communicate with you (e.g., order confirmations, support)</li>
            <li>Prevent abuse and ensure platform security</li>
            <li>Comply with legal obligations</li>
          </ul>
          <p>We do not sell your personal data.</p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">3. Use of AI Tools</h2>
          <p className="mb-4">
            Stickersby.ai uses third-party AI tools (such as OpenAI image generation) to process
            user prompts and generate stickers. Your prompts may be shared with those tools solely
            for the purpose of fulfilling your request.
          </p>
          <p>
            We take steps to avoid storing or linking prompts to identifiable user data unless
            required for service functionality.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">4. Payment Processing</h2>
          <p>
            All transactions are processed by trusted third-party providers (e.g., Stripe). We never
            store full credit card details on our servers.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">5. Data Retention</h2>
          <p>
            We retain your data only as long as needed for legitimate business or legal purposes.
            You can request account deletion by contacting us.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">6. Cookies & Tracking</h2>
          <p>
            We use cookies and analytics tools (e.g., Google Analytics) to understand how users
            interact with the site and improve performance. You can manage cookie preferences in
            your browser settings.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">7. Your Rights</h2>
          <p className="mb-4">Depending on your location, you may have the right to:</p>
          <ul className="list-disc pl-8 mb-4 space-y-1">
            <li>Access your personal information</li>
            <li>Request correction or deletion</li>
            <li>Object to or restrict certain processing</li>
          </ul>
          <p>
            Contact us at{" "}
            <a href="mailto:privacy@stickersby.ai" className="text-primary hover:underline">
              privacy@stickersby.ai
            </a>{" "}
            to exercise your rights.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">8. Children&apos;s Privacy</h2>
          <p>
            Our service is not intended for users under 13. We do not knowingly collect data from
            children.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. The latest version will always be
            available on our site, with the effective date posted at the top.
          </p>
        </section>

        <hr className="border-gray-300 my-8" />

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-4">10. Contact Us</h2>
          <p className="mb-2">Questions? Reach out at:</p>
          <p>
            📧{" "}
            <a href="mailto:support@threetenlabs.com" className="text-primary hover:underline">
              support@threetenlabs.com
            </a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
